import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';
import courseShape from '@prospectus/common/types/courseShape';
import RecommendationsContainer from '@prospectus/common/ui/RecommendationsContainer';
import { FormattedMessage } from 'gatsby-plugin-react-intl';
import useAlgoliaRecommendations from '../ProductRecommendations/hooks/useAlgoliaRecommendations';

function CourseRecommendations({ course, shouldFetchRecommendations }) {
  const { activeCourseRun, skillNames, subjects } = course;

  const algoliaSearchParams = {
    courseRunKeysToExclude: [activeCourseRun.key],
    skills: skillNames,
    subjects: subjects.map((subject) => subject.name),
  };

  const {
    algoliaRecommendations,
    isAlgoliaRecommendationsLoading,
  } = useAlgoliaRecommendations(algoliaSearchParams, !shouldFetchRecommendations);

  if (!isAlgoliaRecommendationsLoading && algoliaRecommendations.length < 4) {
    return null;
  }

  return (
    <div className="bg-light-200 pt-sm-5 pt-4.5 pb-2 pb-sm-4.5">
      <RecommendationsContainer
        recommendations={algoliaRecommendations}
        mainHeading={(
          <FormattedMessage
            id="prospectus.course.detail.recommendations.title"
            defaultMessage="Recommended for you"
            description="Title for a list of recommended courses"
          />
        )}
        alignHeading="center"
      />
    </div>
  );
}

CourseRecommendations.propTypes = {
  course: PropTypes.shape(courseShape).isRequired,
  shouldFetchRecommendations: PropTypes.bool.isRequired,
};

export default track({
  component: 'Course About Page Recommendations',
})(CourseRecommendations);
